export enum CveColumnIndexes {
  CVE_ID = 0,
}

export enum CveColumnKeys {
  CVE_ID = 'cveId',
}

export interface CveRecord {
  cveId: string;
}

export interface CveGridItem {
  cveId: string;
}
